import React from 'react';
import { CollapseIcon } from './icons';
import { ArcIconButton, ArcStack } from '@src/core/ui';
import { useCameraLayout } from './camera-layout-context';
import CameraView from './index';

interface CameraMapLayoutProps {
  children: React.ReactNode;
}

const CameraMapLayout: React.FC<CameraMapLayoutProps> = ({ children: map }) => {
  const { viewMode, cameraSource, collapsed, toggleCollapse } = useCameraLayout();

  const showCamera = !!cameraSource;
  const isPip = showCamera && viewMode === 'pip';
  const isSplit = showCamera && viewMode === 'split';
  const isPipCollapsed = isPip && collapsed;

  return (
    <ArcStack
      direction={isSplit ? 'row' : undefined}
      width='100%'
      height='100%'
      position='relative'>

      <ArcStack
        width={isSplit ? '50%' : '100%'}
        height='100%'
        sx={isPip ? (isPipCollapsed ? {
          display: 'none',
        } : {
          position: 'absolute',
          left: 5,
          bottom: 5,
          width: 400,
          height: 200,
          zIndex: 100,
          borderRadius: 1,
          overflow: 'hidden',
          boxShadow: 3,
        }) : undefined}>
        {isPip
          ? React.cloneElement(map as React.ReactElement, { hideToolbar: true, hideMapControls: true })
          : map}
      </ArcStack>

      {isPipCollapsed && (
        <ArcIconButton
          onClick={toggleCollapse}
          sx={{
            left: 5,
            bottom: 5,
            zIndex: 101,
            position: 'absolute',
            bgcolor: 'background.default',
            borderRadius: 1,
            p: 0.5,
            '&:hover': { bgcolor: 'background.paper' },
            '& .MuiSvgIcon-root': { fontSize: 20 },
          }}>
          <CollapseIcon sx={{ transform: 'rotate(180deg)' }} />
        </ArcIconButton>
      )}

      {showCamera && (
        <ArcStack
          width={isPip ? '100%' : isSplit ? '50%' : undefined}
          height={isPip ? '100%' : isSplit ? '100%' : undefined}
          sx={isPip ? {
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 0,
          } : undefined}>
          <CameraView {...cameraSource} />
        </ArcStack>
      )}
    </ArcStack>
  );
};

export default CameraMapLayout;
